import React from 'react';
import UploadMarksForm from './UploadMarksForm';
import ParentFeedbackGate from './ParentFeedbackGate';
import AssessmentTest from './AssessmentTest';
import GeneralQuestions from './GeneralQuestions';
import { Box, Typography } from '@mui/material';

const NAVY = '#292D5B';

const TestHeader = ({ title, subtitle, hint }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
    <Typography sx={{ fontWeight: 800, fontSize: '16px', color: NAVY, letterSpacing: '0.1px' }}>
      {title}
    </Typography>
    {subtitle && (
      <Typography sx={{ fontSize: '13px', fontWeight: 500, color: '#3E4A66', lineHeight: 1.5 }}>
        {subtitle}
      </Typography>
    )}
    {hint && (
      <Typography sx={{ fontSize: '12.5px', fontWeight: 400, color: '#6B7288' }}>
        {hint}
      </Typography>
    )}
  </Box>
);

const AssessmentStepRender = ({ stepIndex, onComplete }) => {

    switch (stepIndex) {
        case 0:
            return <UploadMarksForm onComplete={onComplete}></UploadMarksForm>;

        case 4:
            return <ParentFeedbackGate onComplete={onComplete} />;

        case 1:
            return <GeneralQuestions onComplete={onComplete} />;

        case 2:
            return (
                <AssessmentTest
                    content={
                        <TestHeader
                            title="Aptitude Test"
                            subtitle="10 sections - 50 questions"
                            hint="Choose an answer, then use Next to continue."
                        />
                    }
                    defaultTest={"adaptive"}
                    onComplete={onComplete}
                />
            );

        case 3:
            return (
                <AssessmentTest
                    content={
                        <TestHeader
                            title="Self-Introspection"
                            subtitle="A quick look inward - your emotions, mindset, and motivation."
                            hint="20 questions - answer honestly, there are no wrong answers."
                        />
                    }
                    defaultTest={"personality"}
                    onComplete={onComplete}
                />
            );

        default:
            return null;
    }
};

export default AssessmentStepRender;

